export default __webpack_public_path__ + "static/media/IMG_5130cropped2.771c3244.jpeg";